import React, { FC } from 'react'
import MediaSettingsContainer from 'components/AssetPanels/Media/Settings/SettingsContainer'
import { SaveSettingsContainer } from 'components/SaveSettings/SaveSettingsContainer'
import { CustomizationHotkeysContainer } from 'components/CustomizationHotkeys/CustomizationHotkeysContainer'
import { CustomizationViewContainer } from 'views/CustomizationView/CustomizationViewContainer'
import { ImportFromUrlContainer } from 'components/ImportFromUrl/ImportFromUrlContainer'
import { NabletHldContainer } from 'components/NabletHld/NabletHldContainer'
import { TranscribeContainer } from 'components/Transcribe/TranscribeContainer'
import { EditorSettingsContainer } from 'components/EditorSettings/EditorSettingsContainer'
import { LogActionsContainer } from 'components/RestartQuestion/LogActionsContainer'
import { InstallComponentMessageContainer } from 'components/RestartQuestion/InstallComponentMessageContainer'
import { ReferenceFileChoiceContainer } from 'components/ReferenceFileChoice/ReferenceFileChoiceContainer'
import { DeleteMediaFilesContainer } from 'components/DeleteMediaFiles/DeleteMediaFilesContainer'
import { QRCodeContainer } from 'components/QRCode/QRCodeContainer'
import { AmazonImportContainer } from 'components/AmazonImport/AmazonImportContainer'

export const ModalView: FC = () => (
  <>
    <MediaSettingsContainer />
    <SaveSettingsContainer />
    <CustomizationHotkeysContainer />
    <CustomizationViewContainer />
    <ImportFromUrlContainer />
    <NabletHldContainer />
    <TranscribeContainer />
    <EditorSettingsContainer />
    <LogActionsContainer />
    <InstallComponentMessageContainer />
    <ReferenceFileChoiceContainer />
    <DeleteMediaFilesContainer />
    <QRCodeContainer />
    <AmazonImportContainer />
  </>
)
